import { Children, useState } from "react";
import styles from "./Tabbable.module.css";

interface TabViewProps {
	readonly children: React.ReactElement<TabProps> | Array<React.ReactElement<TabProps>>;
	readonly style?: React.CSSProperties;
}

export function TabView({ children, style }: TabViewProps) {
	const [activeTab, setActiveTab] = useState(0);

	const tabs = Children.toArray(children) as Array<
		React.ReactElement<TabProps>
	>;

	return (
		<div className={styles.tabbable} style={style}>
			<div className={styles.tablist}>
				{tabs.map((tab, index) => (
					<button
						key={tab.props.title}
						onClick={() => setActiveTab(index)}
						className={index === activeTab ? styles.active : ""}
					>
						{tab.props.title}
					</button>
				))}
			</div>

			{tabs[activeTab]}
		</div>
	);
}

interface TabProps {
	readonly id: string;
	readonly title: string;
	readonly children: React.ReactNode;
	readonly style?: React.CSSProperties;
}
export function Tab(props: TabProps) {
	return <div className={styles.tabcontent} style={props.style}>{props.children}</div>;
}
